import React from "react";
import styles from "./PageProjectDetail.module.css";
import {
  IconAttachMoney,
  IconBoxDevice,
  IconBoxInfo,
  IconNuts,
  IconPigSaving,
  IconUnits,
} from "../../components/Icons/Icons";

export const FoundInformationTab = ({ initialData }) => {
  return (
    <div className="row m-0">
      <div style={{ textAlign: "justify" }} className="tab-container w-50">
        <div className="page-security-head" style={{ padding: "5px 0px 0px" }}>
          <div className="page-security-subtitle" style={{ display: "flex", alignItems: "center" }}>
            <IconBoxDevice
              colorIcon="#1b4ec1"
              height="15px"
              width="15px"
            />
            <span style={{ marginLeft: "10px" }}>Sobre el fideicomiso</span>
          </div>
        </div>
        <div className={`mr-5 ${styles.infoTecBoxText}`}>
          {initialData?.descripcion || "Fideicomiso inmobiliario diseñado para generar rentabilidad a través de la inversión en proyectos de vivienda y oficinas en expansión. Su enfoque está en ubicaciones estratégicas de alta valorización."}
        </div>
      </div>

      <div
        style={{ textAlign: "justify", marginTop: "15px" }}
        className="tab-container w-50"
      >
        <div className="page-security-head" style={{ padding: "5px 0px 0px" }}>
          <div className="page-security-subtitle" style={{ display: "flex", alignItems: "center" }}>
            <IconBoxInfo
              colorIcon={"#1b4ec1"}
              height={"20px"}
              width={"25px"}
            />
            <span style={{ marginLeft: "10px" }}>Información Técnica</span>
          </div>
        </div>

        <div className={styles.infoTec}>
          <div className={styles.infoTecBox}>
            <div className="icon-box" style={{ float: "left" }}>
              <IconPigSaving
                style={{ transform: "translate(0px, 4px)" }}
                height={"20px"}
                width={"20px"}
              />
            </div>
            <div>
              <div className={styles.infoTecBoxTitle}>Tipo de FIC</div>
              <div className={styles.infoTecBoxText}>{initialData?.fund_type || initialData?.tipo || "Inmobiliario"}</div>
            </div>
          </div>
        </div>

        <div style={{ marginTop: "10px" }} className={styles.infoTec}>
          <div className={styles.infoTecBox}>
            <div className="icon-box" style={{ float: "left" }}>
              <IconNuts
                style={{ transform: "translate(0px, 0px)" }}
                height={"30px"}
                width={"30px"}
              />
            </div>
            <div>
              <div className={styles.infoTecBoxTitle}>
                Inicio de operaciones
              </div>
              <div className={styles.infoTecBoxText}>01/01/2022</div>
            </div>
          </div>
        </div>

        <div style={{ marginTop: "10px" }} className={styles.infoTec}>
          <div className={styles.infoTecBox}>
            <div className="icon-box" style={{ float: "left" }}>
              <IconAttachMoney
                style={{ transform: "translate(0px, 0px)" }}
                colorIcon={"#1b4ec1"}
                height={"24px"}
                width={"24px"}
              />
            </div>
            <div>
              <div className={styles.infoTecBoxTitle}>
                Valor del FIC (Millones COP)
              </div>
              <div className={styles.infoTecBoxText}>${((initialData?.price_per_unit || initialData?.valor_unidad || 100000) * (initialData?.amount_units || initialData?.unidades_disponibles || 1000)).toLocaleString('es-CO')}</div>
            </div>
          </div>
        </div>

        <div style={{ marginTop: "10px" }} className={styles.infoTec}>
          <div className={styles.infoTecBox}>
            <div className="icon-box" style={{ float: "left" }}>
              <IconUnits
                style={{ transform: "translate(0px, 0px)" }}
                height={"30px"}
                width={"30px"}
              />
            </div>
            <div>
              <div className={styles.infoTecBoxTitle}>
                N° de Unidades en circulación
              </div>
              <div className={styles.infoTecBoxText}>{(initialData?.amount_units || initialData?.unidades_disponibles || 0).toLocaleString('es-CO')}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
